 /* jshint esversion: 6 */
import axios from "@/utils/request";
import config from "@/configs/defaultConfigs";
import moment from "moment";
import aes from '@/utils/aes';
import Fingerprint2 from 'fingerprintjs2';

const actualConfig = config.Z || config;

const user = {
  state: {
    roles: [],
    // storageValue: 0,
    company: {},
    userInfo: {},
  },
  mutations: {
    SET_TOKEN: (state, {token,  expire, expireTime}) => {
      if (token) {
        localStorage.setItem(actualConfig.ACCESS_TOKEN, token);
        localStorage.setItem(
          actualConfig.ACCESS_TOKEN_TIMEOUT, (expireTime || moment().add((expire || actualConfig.DEFAULT_TIMEOUT), "seconds").format("YYYY-MM-DD HH:mm:ss"))
        );
      } else {
        // 不存在 则清理
        localStorage.removeItem(actualConfig.ACCESS_TOKEN);
        localStorage.removeItem(actualConfig.ACCESS_TOKEN_TIMEOUT);
        state.token = "";
      }
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_INFO: (state, info) => {
      state.userInfo = { ...info, solt: undefined, password: undefined };
    },
    SET_USER_ROLEID_LIST: (state, list) => {
      state.userInfo.roleIdList = list;
    },
    SET_COMPANY: (state, company) => {
      state.company = { ...company };
      if (company && company.id) {
        localStorage.setItem(actualConfig.COMPANY_INFO, company.id);
      } else {
        localStorage.removeItem(actualConfig.COMPANY_INFO);
      }
    },
  },
  actions: {
    INIT_CLIENT_ID({ commit, getters }) {
      return new Promise((resolve, reject) => {
        if (getters.clientId) {
          resolve(getters.clientId)
        } else {
          /**userAgent：浏览器升级会改变，进而影响计算结果
           * plugins:用户安装插件可能性比较大
           * fonts：字体基本都相似，但字体很多也会影响速率*
           **/
          Fingerprint2.get({excludes: {userAgent: true,plugins:true,fonts:true}}, (components) => {
            const values = components.map(function(component,index) {
              if (index === 0 && component.value) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
                return component.value.replace(/\bNetType\/\w+\b/, '')
              }
              return component.value
            })
            // 生成最终id murmur   
            const murmur = Fingerprint2.x64hash128(values.join(''), 31);
            localStorage.setItem("clientId", murmur);
            resolve(murmur)
          })
        }
      });
    },
    // 登录
    Login({ commit, getters }, userInfo) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/sys/login",
          method: "post",
          data: {
            username: userInfo.username,
            password: aes.Encrypt(userInfo.password, userInfo.uuid),
            captcha: userInfo.captcha,
            clientId: (getters.clientId || userInfo.clientId)
          },
        }).then((response) => {
          if (response.code === 200) {
            commit("SET_TOKEN", {token: response.data, expire: response.EXPIRE, expireTime: response.expireTime});
            resolve();
          } else {
            reject(new Error(response.msg));
          }
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 获取登录信息
    LOGIN_CHECK({ commit, getters }, query) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/sys/login_check",
          method: "get",
          params: { clientId: (getters.clientId || query.clientId) },
        })
          .then((response) => {
            if (response.code === 200) {
              console.log('loginCheck', response)
              commit("SET_TOKEN", {token: response.data, expire: response.EXPIRE, expireTime: response.expireTime});
              resolve();
            } else {
              commit("SET_TOKEN", {});
              reject(new Error(response));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户信息
    INIT_INFO({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/manage/user/info",
          method: "get",
        })
          .then((response) => {
            if (response.code === 200) {
              commit("SET_INFO", response.user);
              dispatch("FETCH_COMPANY_LIST", true).then((res) => {
                if (res.list && res.list.length > 0) {
                  const company = localStorage.getItem(actualConfig.COMPANY_INFO);
                  const comp = res.list.find(c => c.id == company);
                  commit("SET_COMPANY", comp ? comp : res.list[0]);
                } else {
                  commit("SET_COMPANY", {});
                }
                dispatch("FETCH_DEPARTMENT_LIST", true);
                dispatch("FETCH_DATA_AUTH_USER_LIST", true);
                // dispatch("FETCH_USER_LIST", true);
                dispatch("FETCH_AUTH_ROLE_LIST", true).then(list => {
                  commit("SET_ROLES", list);
                  commit("SET_USER_ROLEID_LIST", list.map(role => role.id));
                }) ;
                dispatch("FETCH_DICTIONARY_LIST", true);
                dispatch("FETCH_ROLE_LIST", true);
                // 加载通知信息
              });
              resolve(response);
            } else {
              reject(new Error(response.msg));
            }
          }).catch((error) => {
            reject(error);
          });
      });
    },
    setCompany({ commit, state }, company) {
      console.log('state', state.company)
      if (company) {
        commit("SET_COMPANY", company);
      }
    },
    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        axios({
          url: "/sys/logout",
          method: "post",
        }).then((response) => {
            commit("SET_TOKEN", {});
            commit("SET_ROLES", []);
            commit("SET_ROUTERS", []);
            setTimeout(() => {
              resolve(response);
            }, 300);
          })
          .catch((err) => {
            console.error(err);
            setTimeout(() => {
              resolve(err);
            }, 300);
          })
          .finally(() => {
            commit("SET_TOKEN", {});
            commit("SET_ROLES", []);
            commit("SET_ROUTERS", []);
          });
      });
    },
  },
};

export default user;
